import {
  REQUEST,
  RESPONSE,
  CLEAR,
  FAILURE,
  APPEND_TRAININGS
} from '../../actions/models/detail';

const initialState = {
  isLoading: false,
  error: null,
  response: null
};

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case REQUEST:
      return {
        ...state,
        isLoading: true,
        error: null
      };
    case RESPONSE:
      return {
        ...state,
        isLoading: false,
        response: action.payload,
        error: null
      };
    case APPEND_TRAININGS: {
      // If we have no existing data, treat it like a normal response
      if (!state.response) {
        return {
          ...state,
          isLoading: false,
          response: action.payload,
          error: null
        };
      }

      // Only append the new trainings data to the existing trainings
      const existingTrainingsData = state.response.trainings?.data || [];
      const newTrainingsData = action.payload.trainings?.data || [];

      return {
        ...state,
        isLoading: false,
        error: null,
        response: {
          ...state.response,
          trainings: {
            ...action.payload.trainings,
            data: [...existingTrainingsData, ...newTrainingsData]
          }
        }
      };
    }
    case FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.payload
      };
    case CLEAR:
      return initialState;
    default:
      return state;
  }
};
